import { pack } from '@attain-apps/data-utils'
import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import type * as ecModels from '../../../../models'

export type IdentityParams<TTypeParams extends ecModels.TypeParams.Constraint> =
  ExactlyOneOf<{
    readonly id: ecModels.EntityId
    readonly ids: ecModels.EntityId[]
    readonly entity: TTypeParams['entity']
    readonly entities: TTypeParams['entity'][]
  }>
export namespace IdentityParams {
  export function from<TTypeParams extends ecModels.TypeParams.Constraint>(
    { entities, entity, id, ids }: IdentityParams<TTypeParams>,
    collection: ec.Collection<TTypeParams>,
  ): ecModels.EntityId[] {
    // NOTE: Order of if statements is important

    // If Id exist, pack it together on ids, because ids at that point
    // should be undefined
    if (id) {
      ids = pack(id)
    }

    // If entity exist, pack it together on entities, because entities at
    // that point should be undefined
    if (entity) {
      ids = [collection.identify(entity)]
    }

    // If entities exist, map it to ids
    if (entities) {
      ids = entities.map(e => collection.identify(e))
    }

    ids ??= []

    return ids
  }
}
